// Format cents using the shop money format (falls back to a plain number)
function formatSwatchPrice(cents) {
  const settings = (window.theme && window.theme.settings) || {};
  const format = settings.currency_code_enable ? window.theme.moneyWithCurrencyFormat : window.theme && window.theme.moneyFormat;
  const currency = window.themeVendor && window.themeVendor.themeCurrency;

  if (cents === 0 && window.theme && window.theme.strings && window.theme.strings.free) {
    return window.theme.strings.free;
  }
  if (currency && format) {
    return currency.formatMoney(cents, format);
  }
  return (cents / 100).toFixed(2);
}

// Render price / compare at price markup, same as snippets/product-price.liquid
function renderSwatchPrice(priceElement, variant) {
  if (!priceElement || !variant) return;

  const price = formatSwatchPrice(variant.price);

  if (variant.compare_at_price && variant.compare_at_price > variant.price) {
    priceElement.innerHTML = `<span class="product-grid-item__price-new">${price}</span> <s>${formatSwatchPrice(variant.compare_at_price)}</s>`;
  } else {
    priceElement.innerHTML = price;
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const body = document.querySelector('body');
  
  body.addEventListener('click', function(event) {
    // Check if the clicked element is a swatch inside a product card
    if (event.target && event.target.classList.contains('product-card-swatch')) {
      
      const swatch = event.target;
      const productCard = swatch.closest('.product-grid-item');
      
      if (productCard) {
        let mediaImages = productCard.querySelectorAll('.product__media__container img');
        let productTitle = swatch.dataset.productHandle;
        const productTitleElements = productCard.querySelectorAll('a.product-grid-item__title.font-body');
        let actualPrice = productCard.querySelector('.product-grid-item__price');
        var quickBuyModal = productCard.querySelector('quick-buy-modal');
        const featuredMedia = productCard.querySelectorAll('deferred-loading.product__media__image.product__media__image--hover-fade-in');
        const hoverImage  = productCard.querySelectorAll('deferred-loading.product__media__hover.product__media__hover--fade-in');

        
        // Remove 'active' class from all swatches
        productCard.querySelectorAll('.product-card-swatch').forEach(function(s) {
          s.classList.remove('active');
        });
        // Add 'active' class to the clicked swatch
        swatch.classList.add('active');
        let productUrl = `${window.location.origin}/products/${productTitle}.js`;
        // Fetch product data
        fetch(productUrl)
          .then(response => {
            if (!response.ok) {
              throw new Error('Network response was not ok ' + response.statusText);
            }
            return response.json();
          })
          .then(data => {
            // Update product title elements
            if (productTitleElements && data && data.title) {
              productTitleElements.forEach((element) => {
                element.innerHTML = data.title;
              });
            }
            // Update product URLs in anchors
            productCard.querySelectorAll('a').forEach(function(anchor) {
              anchor.setAttribute('href', data.url);
            });
            // Update price and compare at price with the first available variant
            if (actualPrice && data && data.variants && data.variants.length) {
              const variant = data.variants.find((item) => item.available) || data.variants[0];
              renderSwatchPrice(actualPrice, variant);
            }
            if (featuredMedia.length > 0) {
                featuredMedia.forEach(media => {
                    const imageElement = media.querySelector('img');
                    if (imageElement) {
                        imageElement.src = data.featured_image;
                        imageElement.srcset = data.featured_image;
                    } else {
                        console.error('No <img> element found inside featuredMedia.');
                    }
                });
            } else {
                console.error('No elements found with the class .product__media__image.');
            }
            if (hoverImage.length > 0) {
              hoverImage.forEach(media => {
                  const imageElement = media.querySelector('img');
                  if (imageElement) {
                      imageElement.src = data.images[0];
                      imageElement.srcset = data.images[0];
                  } else {
                      console.error('No <img> element found inside hoverImage.');
                  }
              });
            }
          })
          .catch(error => {
            console.log('There was a problem with the fetch operation:', error);
          });
      }
    }
  });
});